import { useNavigate, Link } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-3 md:py-4">
        {/* Mobile: Stack vertically, Desktop: Side by side */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          {/* Logo */}
          <Link to="/" className="flex items-center justify-center sm:justify-start gap-2 cursor-pointer">
            <img src="/logo.png" alt="ChatHub India" className="h-8 sm:h-10 w-auto" />
            <span className="text-xl sm:text-2xl font-bold text-gray-900">ChatHub</span>
          </Link>
          {/* Navigation Buttons */}
          <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap">
            <button
              onClick={() => navigate('/auth')}
              className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base text-gray-700 hover:text-gray-900 font-medium"
            >
              Guest Login
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base text-blue-600 hover:text-blue-700 font-medium"
            >
              User Login
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="px-4 py-1.5 sm:px-6 sm:py-2 text-sm sm:text-base bg-gray-900 text-white rounded-lg hover:bg-gray-800 font-medium"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
